export default __webpack_public_path__ + "static/media/a2-4-15.3271b310.jpg";